module.exports = __webpack_public_path__ + "img/8blue.413a5e89.png";